'use strict';exports.__esModule = true;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {return typeof obj;} : function (obj) {return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;};



// Styles
var _react = require('react');var _react2 = _interopRequireDefault(_react);var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);var _OMAccordion = require('../OMComponents/OMAccordion/OMAccordion');var _OMAccordion2 = _interopRequireDefault(_OMAccordion);var _SavedSearchesCell = require('./SavedSearchesCell.scss');var styles = _interopRequireWildcard(_SavedSearchesCell);
var _index = require('../index');
var _OMGenericSelect = require('../OMComponents/OMGenericSelect/OMGenericSelect');var _OMGenericSelect2 = _interopRequireDefault(_OMGenericSelect);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var SavedSearchesCell = function SavedSearchesCell(props) {var
  name = props.name,email = props.email,search = props.search,createdAt = props.createdAt,showResults = props.showResults,translate = props.translate,removeSearch = props.removeSearch,toggleSmartAgentState = props.toggleSmartAgentState;

  var getAddressValue = function getAddressValue(data) {
    var addressObject = (0, _get2.default)(data, 'locationSearch.en');
    var result = '';

    if (addressObject) {
      var city = addressObject.city_name;
      var neighborhood = addressObject.neighborhood;
      var street = addressObject.street_name;
      var house = addressObject.house_number;

      var neighborhoodPart = neighborhood ? ' ' + neighborhood + ', ' : '';
      var housePart = house ? ' ' + house + ', ' : ', ';
      var streetPart = street ? '' + street + housePart : '';

      result = '' + streetPart + neighborhoodPart + city;
    }

    return result;
  };

  var getFormattedValue = function getFormattedValue(itemName, value) {
    switch (typeof value === 'undefined' ? 'undefined' : _typeof(value)) {
      case 'boolean':{
          return translate('savedSearches', value ? 'yes' : 'any');
        }
      case 'string':{
          return value;
        }
      case 'object':{
          if (value instanceof Array) {
            if (value.length) {
              if (['commodities', 'types'].includes(itemName)) {
                var customTranslate = itemName === 'types' ? translate('propertyTypes') : translate('propertyDetails', 'commodities');
                return value.map(function (item) {return customTranslate(item);}).join(', ');
              }

              return value.join(', ');
            }

            return translate('savedSearches', 'any');
          }

          if (value instanceof Object) {
            var postfix = value.minPrice || value.maxPrice ? 'Price' : '';
            var minValueName = 'min' + postfix;
            var maxValueName = 'max' + postfix;
            var minValue = value[minValueName] || '';
            var maxValue = value[maxValueName] || '';
            var separator = minValue && maxValue ? ' - ' : '';
            var prefix = '';

            if (minValue && !maxValue) {
              prefix = '>';
            }

            if (!minValue && maxValue) {
              prefix = '<';
            }

            return prefix + ' ' + minValue + separator + maxValue;
          }

          break;
        }
      default:return value;}


    return value;
  };

  var renderHighlightItem = function renderHighlightItem(title, value) {return (
      _react2.default.createElement('div', { key: title + '_' + value, className: styles.highlightItem },
        _react2.default.createElement('div', null, translate('savedSearches', title), ':'), _react2.default.createElement('div', null, value)));};



  var renderHighlights = function renderHighlights(data) {
    var params = (0, _get2.default)(data, 'params', { rooms: [], types: [], price: [] });

    var list = Object.keys(params).map(function (itemName) {
      var value = params[itemName];
      var formattedValue = getFormattedValue(itemName, value);

      return renderHighlightItem(itemName, formattedValue);
    });

    var optionType = translate('header', data.optionType);
    var sectionValue = !data.location || data.location === 'homes' ? 'residence' : data.location;
    var section = translate('publishProperty', 'initialPropertyDetailsSection', sectionValue);
    var address = getAddressValue(search);
    var optionItem = renderHighlightItem('optionType', optionType);
    var sectionItem = renderHighlightItem('section', section);
    var addressItem = address ? renderHighlightItem('address', address) : null;

    return address ? [addressItem, sectionItem, optionItem].concat(list) : [sectionItem, optionItem].concat(list);
  };

  var renderAgentStateButton = function renderAgentStateButton() {return (
      _react2.default.createElement('div', { className: styles.disableAgent, onClick: function onClick(evt) {return evt.stopPropagation();} },
        _react2.default.createElement(_index.OMSwitch, {
          id: 'smart-agent-switch',
          label: translate('savedSearches', search.smartAgentIsActive ? 'enable' : 'disable').toString(),
          onChange: toggleSmartAgentState,
          isChecked: !!search.smartAgentIsActive })));};




  var renderHeadRow = function renderHeadRow() {return (
      _react2.default.createElement('div', { className: styles.accordionHeadRow },
        _react2.default.createElement('div', null, name),
        _react2.default.createElement('div', { className: styles.savedSearchesButtonsWrapper, ref: props.getInnerRef || function () {} },
          _react2.default.createElement('div', { className: styles.email },
            _react2.default.createElement('span', null, email)),

          _react2.default.createElement('div', { className: styles.savedDate },
            _react2.default.createElement('span', null, createdAt)),


          renderAgentStateButton(),

          _react2.default.createElement('div', { className: styles.select, onClick: function onClick(evt) {return evt.stopPropagation();} },
            _react2.default.createElement(_OMGenericSelect2.default, {
              options: [{
                label: translate('savedSearches', 'daily'),
                selected: true,
                value: 'daily' }],

              value: 'daily',
              onChange: function onChange() {} })),



          _react2.default.createElement('button', { onClick: showResults, className: styles.showResults },
            translate('savedSearches', 'showResults')),


          _react2.default.createElement('button', { onClick: removeSearch, className: styles.removeSearch },
            _react2.default.createElement('span', { className: 'icon icon-delete_bucket' })))));};





  return (
    _react2.default.createElement('div', { className: styles.savedSearchesCell },
      _react2.default.createElement(_OMAccordion2.default, {
          titleValue: renderHeadRow(),
          className: styles.smartAgentAccordion },

        _react2.default.createElement('div', { className: styles.savedDatailsWrapper },
          renderHighlights(search)))));




};

SavedSearchesCell.propTypes = {
  translate: _propTypes2.default.func.isRequired,
  getInnerRef: _propTypes2.default.func,
  name: _propTypes2.default.string,
  email: _propTypes2.default.string,
  search: _propTypes2.default.object,
  filters: _propTypes2.default.string,
  createdAt: _propTypes2.default.string,
  showResults: _propTypes2.default.func,
  toggleSmartAgentState: _propTypes2.default.func,
  removeSearch: _propTypes2.default.func };exports.default =


SavedSearchesCell;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/SavedSearchesCell/SavedSearchesCell.js
// module id = 2877
// module chunks = 0